var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 1.71094H0.571429C0.255357 1.71094 0 1.96629 0 2.28237V13.7109C0 14.027 0.255357 14.2824 0.571429 14.2824H15.4286C15.7446 14.2824 16 14.027 16 13.7109V2.28237C16 1.96629 15.7446 1.71094 15.4286 1.71094ZM1.28571 2.99665H14.7143V5.13951H1.28571V2.99665ZM14.7143 12.9967H1.28571V6.71094H14.7143V12.9967ZM10.4821 11.8538H13.4286C13.5071 11.8538 13.5714 11.7895 13.5714 11.7109V10.4252C13.5714 10.3467 13.5071 10.2824 13.4286 10.2824H10.4821C10.4036 10.2824 10.3393 10.3467 10.3393 10.4252V11.7109C10.3393 11.7895 10.4036 11.8538 10.4821 11.8538Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon_document.5302020a8622d11a71b62dac3f80dc29.svg";
export { ForwardRef as ReactComponent };